/**
 * @name: call
 * @description: 呼叫中心
 * @author: qq2575896094
 * @time: 2024/8/15
 */

const prefix = '/onlinecs/calling'

/**
 * 查看呼叫记录
 * @type {string}
 */
export const queryCallingRecord = `${prefix}/queryCallingRecord`

/**
 * 查询坐席信息
 * @type {string}
 */
export const queryCallAgentData = `${prefix}/queryCallAgentData`

/**
 * 下载通话详情录音文件
 * @type {string}
 */
export const downloadDetailRecordFile = `${prefix}/downloadDetailRecordFile`

/**
 * 修改通话备注
 * @type {string}
 */
export const modityCallingRemark = `${prefix}/modityCallingRemark`
